//This file is automatically rebuilt by the Cesium build process.
export default "/**\n\
 * 0.00001\n\
 *\n\
 * @name czm_epsilon5\n\
 * @glslConstant\n\
 */\n\
const float czm_epsilon5 = 0.00001;\n\
";